import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';

@Injectable({
  providedIn: 'root'
})
export class VendorGroupsPlansService {

  constructor(
      private restangular: ApiClient
  ) { }

  getAllVendorGroupPlans(limit = 10000, offset = 0, search = ''): Promise<any> {
    return this.restangular.one(`/vendors/groups/plans?limit=${limit}&offset=${offset}&search=${search}`).get().toPromise();
  }

  createVendorGroupPlan(productIds: string, metadata: any): Promise<any> {
    return this.restangular.one('/vendors/groups/plans', productIds).customPOST({
      ...metadata,
    }).toPromise();
  }

  modifyVendorGroupPlan(id: string, fields: any): Promise<any> {
    return this.restangular.one('/vendors/groups/plans', id).customPUT({
      ...fields
    }).toPromise();
  }

  deleteVendorGroupPlan(id: string): Promise<any> {
    return this.restangular.one('vendors/groups/plans', id).remove().toPromise();
  }

}
